import axios from 'axios'
import applicationUserManager from '../core/applicationusermanager'
import store from '../store'
import { apiConfig } from './apiConfig'

const baseDomain = `${apiConfig.url}`
const baseURL = `${baseDomain}`

const axiosClient = axios.create({
  baseURL,
  headers: {
    crossorigin: 'true',
    'Content-Type': 'application/json'
  }
})

axiosClient.interceptors.request.use(req => {
  const token = applicationUserManager.getAccessToken()
  if (token) {
    req.headers.authorization = `Bearer ${token}`
  }
  return req
})

// Tilføj en response interceptor
axios.interceptors.response.use(
  function (response) {
    // Gør noget med svaret
    return response
  },
  function (error) {
    if (error.message === 'Network Error') {
      // Håndter offline-tilstand globalt
      console.log('Offline-tilstand: Ingen netværksforbindelse')
    } else {
      // Håndter andre fejl globalt
      console.error('Fejl under anmodning:', error.message)
    }

    return Promise.reject(error)
  }
)

export default axiosClient
